import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import { ContentHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/ContentHubFaqs';
import { ContentHubProductIcon } from 'pricing-pages-ui-components/productIcon/ContentHubProductIcons';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import { ContentHubFeatureTable } from './ContentHubFeatureTable';
import { ContentHubMerchCards } from './ContentHubMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CONTENT_HUB_API_NAMES = [Products.CMS_HUB_STARTER, Products.CMS_HUB_PROFESSIONAL, Products.CMS_HUB_ENTERPRISE];
export const ContentHubPage = () => {
  useDocumentTitle('content');
  useEffect(() => {
    trackPageView({
      screen: 'content'
    });
  }, []);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "CONTENT_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "CONTENT",
      apiNames: CONTENT_HUB_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(ContentHubProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.content.pageTitle"
        })]
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.content.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ContentHubMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "content"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ContentHubFeatureTable, {})
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "content"
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "1400",
      children: /*#__PURE__*/_jsx(ContentHubFaqs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "cms-footer",
      screen: "content",
      apiName: Products.CMS_HUB_STARTER
    })]
  });
};